"use strict";

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var EventTargetImpl = require("../events/EventTarget-impl").implementation;

var idlUtils = require("../generated/utils");

var _require = require("../helpers/create-event-accessor"),
    setupForSimpleEventAccessors = _require.setupForSimpleEventAccessors;

var events = ["loadstart", "progress", "abort", "error", "load", "timeout", "loadend"];

var XMLHttpRequestEventTargetImpl =
/*#__PURE__*/
function (_EventTargetImpl) {
  _inherits(XMLHttpRequestEventTargetImpl, _EventTargetImpl);

  function XMLHttpRequestEventTargetImpl() {
    _classCallCheck(this, XMLHttpRequestEventTargetImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(XMLHttpRequestEventTargetImpl).apply(this, arguments));
  }

  _createClass(XMLHttpRequestEventTargetImpl, [{
    key: "_ownerDocument",
    // TODO: remove this when we fix EventTargetImpl to use this._globalObject directly instead of using _ownerDocument.
    // https://github.com/jsdom/jsdom/issues/2780
    get: function get() {
      return idlUtils.implForWrapper(this._globalObject._document);
    }
  }]);

  return XMLHttpRequestEventTargetImpl;
}(EventTargetImpl);

setupForSimpleEventAccessors(XMLHttpRequestEventTargetImpl.prototype, events);
exports.implementation = XMLHttpRequestEventTargetImpl;